import React from "react";
import { Button } from "../../ui/button";

/**
 * RecorderControlsBar — the Start/Pause/Resume/Stop button row (during
 * setup phase) or the Retake button (during review phase). Pure
 * presentational; parent owns recording lifecycle + handlers.
 *
 * Props:
 *   recordPhase    — "setup" | "review"
 *   isRecording    — bool
 *   isPaused       — bool
 *   cameraReady    — bool, disables Start when camera not yet live
 *   onStart, onPause, onResume, onStop, onRetake — handlers
 */
export const RecorderControlsBar = ({
  recordPhase, isRecording, isPaused, cameraReady,
  onStart, onPause, onResume, onStop, onRetake,
}) => (
  <div className="flex flex-wrap gap-2 mt-3">
    {recordPhase === "setup" ? (
      !isRecording ? (
        <Button
          size="sm"
          onClick={onStart}
          disabled={!cameraReady}
          className="bg-rose-600 hover:bg-rose-500 text-white font-semibold"
          data-testid="start-recording-btn"
        >
          <span className="w-2 h-2 rounded-full bg-white mr-2" />
          Start Recording (up to 3 min)
        </Button>
      ) : (
        <>
          {!isPaused ? (
            <Button
              size="sm"
              onClick={onPause}
              className="bg-amber-600 hover:bg-amber-500 text-white"
              data-testid="pause-recording-btn"
            >
              Pause
            </Button>
          ) : (
            <Button
              size="sm"
              onClick={onResume}
              className="bg-emerald-600 hover:bg-emerald-500 text-white"
              data-testid="resume-recording-btn"
            >
              Resume
            </Button>
          )}
          <Button
            size="sm"
            onClick={onStop}
            variant="outline"
            className="border-rose-700 text-rose-300 hover:bg-rose-900/30"
            data-testid="stop-recording-btn"
          >
            Stop
          </Button>
        </>
      )
    ) : (
      <Button
        size="sm"
        onClick={onRetake}
        variant="outline"
        className="border-gray-700 text-gray-300"
        data-testid="retake-btn"
      >
        Retake
      </Button>
    )}
  </div>
);
